// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__N04Gw","rootCenter":"LoadMoreObserver_rootCenter__34RyE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3LQjq"};